import React, { Component } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF, toLocalDate } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class DevKeyItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode, shops } = this.props

    const selectedShop = shops.find((shop) => shop.id === data.shopId) || {}

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.shopId}
            onChange={this.onChange('shopId')}
            valueToRender={selectedShop.name}
            editMode={editMode}
          >
            {shops.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name || ''}
            value={data.name || ''}
            editMode={editMode}
            onChange={this.onChange('name')}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">{data.key}</TableCell>
        <TableCell className="cell-wrap-word">{data.secret}</TableCell>
        <TableCell className="cell-wrap-word">
          {(data.created && toLocalDate(data.created)) || ''}
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.active ? 'Active' : 'Inactive'}
            checked={data.active}
            editMode={editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enableExposeSales ? 'Enabled' : 'Disabled'}
            checked={data.enableExposeSales}
            editMode={editMode}
            onChange={this.onChange('enableExposeSales', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enableExposeMembers ? 'Enabled' : 'Disabled'}
            checked={data.enableExposeMembers}
            editMode={editMode}
            onChange={this.onChange('enableExposeMembers', true)}
          />
        </TableCell>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DevKeys/DevKeyItem.js